export default __webpack_public_path__ + "static/media/login_bg.6d3c101a.jpg";